import { render, staticRenderFns } from "./vehicle-box-big.vue?vue&type=template&id=bd3565ec&scoped=true&lang=pug&"
import script from "./vehicle-box-big.vue?vue&type=script&lang=js&"
export * from "./vehicle-box-big.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-box-big.vue?vue&type=style&index=0&id=bd3565ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3565ec",
  null
  
)

export default component.exports